export default __webpack_public_path__ + "static/media/oa_2.3ea493ac.mp3";